import { getConfigValue } from '@shared/utils/config';
import { DefaultTheme } from 'styled-components';
import * as O from 'fp-ts/Option';

const repositoryName = O.getOrElse(() => 'vegetag')(getConfigValue('VITE_PRISMIC_REPOSITORY'));

const theme: DefaultTheme =
  repositoryName === 'vegetag'
    ? {
        colors: {
          primary: '#a4a01a',
          secondary: '#731b1b',
          white: '#ffffff',
          black: '#000000',
          text: '#585045',
          highlight: 'rgba(164, 160, 26, 0.5)',
        },
        font: {
          family: "'Barlow', sans-serif",
          weights: {
            regular: 400,
            medium: 500,
            semiBold: 600,
            bold: 700,
          },
          sizes: {
            extraLarge: '24px',
            large: '20px',
            standard: '16px',
            medium: '15px',
            small: '14px',
            extraSmall: '13px',
          },
        },
      }
    : {
        colors: {
          primary: '#30583a',
          secondary: '#75b843',
          white: '#ffffff',
          black: '#000000',
          text: '#75b843',
          highlight: 'rgba(164, 160, 26, 0.5)',
        },
        font: {
          family: "'Open Sans', sans-serif",
          weights: {
            regular: 400,
            medium: 500,
            semiBold: 600,
            bold: 700,
          },
          sizes: {
            extraLarge: '24px',
            large: '20px',
            standard: '16px',
            medium: '15px',
            small: '14px',
            extraSmall: '13px',
          },
        },
      };

export default theme;
